<template>
  <div class="profit">
    <!-- <Header titles="开票流程"></Header> -->
    <img class="pros" :src="imgs.op1" alt="">
    <img class="pros" :src="imgs.op2" alt="">
  </div>
</template>

<script>
// import Header from '@/components/header.vue'
export default {
  data() {
    return {
      imgs: {
        op1: require('../../assets/invo/explain1.png'),
        op2: require('../../assets/invo/explain2.png')
      }
    }
  },
  components: {
    // Header
  },
}
</script>

<style lang="scss" scoped>
.profit {
  // padding-top:44px ;
    text-align: center;
  .pros {
    width: 100%;
    margin: -3px 0;
  }
}
</style>